<mat-form-field (keyup.enter)="$event.stopPropagation(); enter.emit()" [matTooltip]="TOOLTIP">
  <mat-label>Standort</mat-label>
  <mtx-select
    appendTo="body"
    [items]="(locationList$ | async) ?? []"
    [typeahead]="locationListTypeahead$"
    [loading]="locationListLoading"
    [virtualScroll]="false"
    [minTermLength]="3"
    [typeToSearchText]="this.translateService.stream('formErrors.min_char', { chars: 3 }) | async"
    (change)="onChange($event)"
    [clearable]="false"
    [(ngModel)]="selectedLocation"
  >
    <ng-template ng-label-tmp let-item="item">
      <span>
        {{ item.objektbezeichnung }} | {{ item.strasse }}, {{ item.plz }} {{ item.ort }} |
        {{ item.gsusNummer }} | {{ item.wirtschaftseinheit }}
      </span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <span>
        {{ item.objektbezeichnung }} | {{ item.strasse }}, {{ item.plz }} {{ item.ort }} |
        {{ item.gsusNummer }} | {{ item.wirtschaftseinheit }}
      </span>
    </ng-template>
  </mtx-select>
</mat-form-field>
<button
  type="button"
  mat-icon-button
  color="primary"
  aria-label="Clear"
  matTooltip="Standort zurücksetzen"
  (click)="resetLocation()"
>
  <mat-icon>highlight_off</mat-icon>
</button>
